import RightBarMethod from "../../../components/common/RightBar/RightBarMethod";
// label, key, icon, children,url
export const DashboardRightBar = [
  RightBarMethod(
    " CALENDAR",
    "t1",
    <i className="fa-solid fa-calendar-days"></i>,
    [RightBarMethod("View Calendar", "1", "", "", "/CalendarPage")]
  ),
  RightBarMethod(" PROPERTY", "t2", <i className="fa-solid fa-house"></i>, [
    RightBarMethod("New Property", "3", "", "", "/properties/new"),
  ]),
  RightBarMethod(
    " PEOPLE",
    "t3",
    <i className="fa-sharp fa-solid fa-people-group"></i>,
    [
      RightBarMethod(
        "Move In Tenant",
        "4",
        "",
        "",
        "/people/tenants/move-in-tenant"
      ),
      RightBarMethod(
        "Tenant Receipt",
        "5",
        "",
        "",
        "/accounting/receivables_payments/reciepts/tenant_receipts/new"
      ),
      RightBarMethod(
        "Homeowner Receipt",
        "6",
        "",
        "",
        "/accounting/receivables_payments/reciepts//HomeownerReceipt"
      ),
      RightBarMethod(
        "Enter Bill",
        "7",
        "",
        "",
        "/accounting/payables_bills/bills/enter-bils"
      ),
      RightBarMethod("New Owner", "8", "", "", "/people/owners/new"),
      RightBarMethod("New Vendor", "9", "", "", "/people/vendors/new"),
      RightBarMethod("Rent Increase", "10", "", "", "/rent_increase"),
      RightBarMethod(
        "Enter Utility Bill (RUBS)",
        "11",
        "",
        "",
        "/accounting/payables_bills/bills/utility-bill-details"
      ),
    ]
  ),
  RightBarMethod(
    " REPORTS",
    "t4",
    <i className="fa-solid fa-chart-column"></i>,
    [
      RightBarMethod("Delinquency", "12", "", "", "/"),
      RightBarMethod("Tenant Ledger", "13", "", "", "/"),
      RightBarMethod("Unit Vacancy Detail", "14", "", "", "/"),
      RightBarMethod("Rent Roll", "15", "", "", "/"),
      RightBarMethod("Cash Flow", "16", "", "", "/"),
      RightBarMethod("Lease Expiration Detail By Month", "17", "", "", "/"),
    ]
  ),
  RightBarMethod(" LETTERS", "t5", <i className="fa-solid fa-file-lines"></i>, [
    RightBarMethod("3-Day Notices", "18", "", "", "/"),
  ]),
  RightBarMethod(" ACCOUNT", "t6", <i className="fa-solid fa-gears"></i>, [
    RightBarMethod("Property Groups", "19", "", "", "/"),
  ]),
];

export const DashboardCards = [
  {
    key: "item-1",
    header: "Move Ins",
    inPanel: "You have no upcoming move ins.",
    isHidden: false,
    isCollapsed: false,
  },
  {
    key: "item-2",
    header: "Upcoming Income Recertifications",
    inPanel: "There are no upcoming income certifications at this time.",
    isHidden: false,
    isCollapsed: false,
  },
  {
    key: "item-3",
    header: "Online Payments",
    inPanel: "There are no upcoming income certifications at this time",
    isHidden: false,
    isCollapsed: false,
  },
  {
    key: "item-4",
    header: "Notifications",
    inPanel: "Activities",
    isHidden: false,
    isCollapsed: false,
  },
  {
    key: "item-5",
    header: "Leasing Activity (Last 30 Days)",
    inPanel: "There are no upcoming income certifications at this time",
    isHidden: false,
    isCollapsed: false,
  },
  {
    key: "item-6",
    header: "Portfolio Summary",
    inPanel: "There are no upcoming income certifications at this time",
    isHidden: false,
    isCollapsed: false,
  },
  {
    key: "item-7",
    header: "Delinquencies",
    inPanel: "There are no upcoming income certifications at this time",
    isHidden: false,
    isCollapsed: false,
  },
  {
    key: "item-8",
    header: "Maintenance",
    inPanel: "There are no upcoming income certifications at this time",
    isHidden: false,
    isCollapsed: false,
  },
  {
    key: "item-9",
    header: "Move Outs",
    inPanel: "There are no upcoming income certifications at this time",
    isHidden: false,
    isCollapsed: false,
  },
  {
    key: "item-10",
    header: "Insurance Coverage",
    inPanel: "There are no upcoming income certifications at this time",
    isHidden: false,
    isCollapsed: false,
  },
  {
    key: "item-11",
    header: "Association Approvals",
    inPanel: "There are no upcoming income certifications at this time",
    isHidden: false,
    isCollapsed: false,
  },
];
